// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.inscription-fee__container {
    width: 100%;
    background-color: var( --white-color );
}

.inscription-fee__team {
    /* margin-bottom: var( --space-x3 ); */
}

.inscription-fee__team-player {
    border: 2px solid var( --new-gray-disabled-color );
    border-radius: var( --space-half-quarter );
    padding: var( --space-and-half );
    margin-bottom: var( --space-and-half );
}

.inscription-fee__team .left-col .baloa-table {
    color: var( --primary-dark-color );
}

.inscription-fee__player .left-col .baloa-table {
    color: var( --primary-dark-color );
    margin-right: var( --space-half );
}

.inscription-fee__container .baloa-username {
    font-weight: var( --font-medium );
    color: var( --primary-very-dark-color );
}

.inscription-fee__increase-decrease__value {
    margin-left: var( --space-and-half );
    display: flex;
    align-items: center;
    background-color: var( --new-background-color );
    padding: var( --space-eighth );
    border-radius: var( --space-quarter );
}

.inscription-fee__increase-decrease__value .btn {
    background-color: var( --new-green-color );
    color: var( --white-color );
    width: var( --space-and-half );
    height: var( --space-and-half );
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var( --space-quarter );
    cursor: pointer;
}

.inscription-fee__increase-decrease__value .btn.disabled {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.5;
}

.inscription-fee__increase-decrease__value input {
    border: none;
    background-color: transparent;
    max-width: var( --space-and-half );
    text-align: center;
}

.inscription-fee__increase-decrease__value input:focus {
    outline: none;    
}

.inscription-fee__increase-decrease__value input[type=number]::-webkit-inner-spin-button,
.inscription-fee__increase-decrease__value input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.inscription-fee__team, .inscription-fee__player {
    gap: 100px;
}

.inscription-fee__team,
.inscription-fee__team .left-col,
.inscription-fee__player,
.inscription-fee__player .left-col,
.inscription-fee__player .right-col {
    display: flex;
    align-items: center;
}

.inscription-fee__player {
    margin-top: var( --space-x3 );
}

.inscription-fee__team .left-col,
.inscription-fee__team .right-col,
.inscription-fee__player .left-col,
.inscription-fee__player .right-col {
    width: 100%;
}

.inscription-fee__team-player .icon-player, .inscription-fee__team-player .icon-team {
    font-size: var( --space-x2 );
    color: var( --new-green-color );
    margin-right: 8px;
}

.inscription-fee__overall-fee{
    display: flex;
    justify-content: flex-start;
    margin-top: 12px;
}
.inscription-fee__overall-fee div{
    padding-bottom: 2px;
}

.inscription-fee__overall-fee .baloa-normal {
    color: var(--primary-very-dark-color);
    font-size: calc(var(--space) + var(--space-eighth) );/* 18px */
}

.inscription-fee__overall-fee .baloa-subtitle-2 {
    color: var(--primary-very-dark-color);
}

.right-col_isMobile {
    display: flex;
    margin-left: 4rem;
    align-items: center;
}

.inscription-fee__coupon {
    margin-top: 30px;
}

.inscription-fee__coupon .baloa-table-column {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.inscription-fee__form {
    margin-bottom: 44px;
}

.inscription-fee__form .input-field  {
    margin: 0;
    margin-top: 4px;
    width: 100%;
}

.inscription-fee__form .input-field-label {
    font-size: var(--space);
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.inscription-fee__form .input-field-input  {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    background: var(--white-color);
    padding: 12px;
}

.inscription-fee__form .secondary-button {
    padding: 10px 12px;
    width: unset;
    margin-top: 0;
}

.inscription-fee__form-coupon {
    display: flex;
    align-items: center;
    gap: 4px;
}

.inscription-fee__coupon .baloa-mini.error {
    color: var(--error-color);
}

.inscription-fee__form .input-field.error .input-field-input {
    border-color: var(--error-color);
}

.inscription-fee__coupon-valid {
    border: 1px solid var(--new-green-color);
    border-radius: 8px;
    display: flex;
    padding: 10px 16px 10px 12px;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 44px;
    margin-top: 4px;
}

.inscription-fee__coupon-valid .hubicon-check_circle {
    font-size: 24px;
    margin-right: 12px;
}

.inscription-fee__coupon-valid .baloa-table-column {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.inscription-fee__coupon-valid .baloa-username {
    color: var(--basic-gray-color);
    margin-top: 4px;
}

.inscription-fee__coupon-valid .baloa-table-column.delete-button {
    color: var(--error-color);
    font-weight: var(--font-medium);
    margin-left: auto;
    cursor: pointer;
}

.inscription-fee__coupon-discount .baloa-table {
    color: var(--primary-dark-color) !important;
    margin-top: 16px;
}


@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .inscription-fee__team 
    .left-col, 
    .inscription-fee__team 
    .right-col, .inscription-fee__player 
    .left-col, .inscription-fee__player 
    .right-col {
        width: 100%;
    }

    .inscription-fee__team, 
    .inscription-fee__team 
    .left-col, .inscription-fee__player, 
    .inscription-fee__player .left-col, 
    .inscription-fee__player .right-col {
        display: flex;
        align-items: center;
    }

    .inscription-fee__player {
        margin-top: 25px;
    }

    .inscription-fee__team-player .right-col_isMobile {
        margin-left: 2em;
    }
    
}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/inscriptions-fee/InscriptionsFeeComponent.styles.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,kDAAkD;IAClD,0CAA0C;IAC1C,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IACjC,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,+CAA+C;IAC/C,8BAA8B;IAC9B,qCAAqC;AACzC;;AAEA;IACI,0CAA0C;IAC1C,2BAA2B;IAC3B,8BAA8B;IAC9B,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;;;;;IAKI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;;;IAII,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,oDAAoD,CAAC,SAAS;AAClE;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,2CAA2C;IAC3C,gBAAgB;AACpB;;;AAGA,yCAAyC,4BAA4B;IACjE;;;;;;QAMI,WAAW;IACf;;IAEA;;;;;QAKI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;AAEJ","sourcesContent":["\n.inscription-fee__container {\n    width: 100%;\n    background-color: var( --white-color );\n}\n\n.inscription-fee__team {\n    /* margin-bottom: var( --space-x3 ); */\n}\n\n.inscription-fee__team-player {\n    border: 2px solid var( --new-gray-disabled-color );\n    border-radius: var( --space-half-quarter );\n    padding: var( --space-and-half );\n    margin-bottom: var( --space-and-half );\n}\n\n.inscription-fee__team .left-col .baloa-table {\n    color: var( --primary-dark-color );\n}\n\n.inscription-fee__player .left-col .baloa-table {\n    color: var( --primary-dark-color );\n    margin-right: var( --space-half );\n}\n\n.inscription-fee__container .baloa-username {\n    font-weight: var( --font-medium );\n    color: var( --primary-very-dark-color );\n}\n\n.inscription-fee__increase-decrease__value {\n    margin-left: var( --space-and-half );\n    display: flex;\n    align-items: center;\n    background-color: var( --new-background-color );\n    padding: var( --space-eighth );\n    border-radius: var( --space-quarter );\n}\n\n.inscription-fee__increase-decrease__value .btn {\n    background-color: var( --new-green-color );\n    color: var( --white-color );\n    width: var( --space-and-half );\n    height: var( --space-and-half );\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: var( --space-quarter );\n    cursor: pointer;\n}\n\n.inscription-fee__increase-decrease__value .btn.disabled {\n    cursor: not-allowed;\n    pointer-events: none;\n    opacity: 0.5;\n}\n\n.inscription-fee__increase-decrease__value input {\n    border: none;\n    background-color: transparent;\n    max-width: var( --space-and-half );\n    text-align: center;\n}\n\n.inscription-fee__increase-decrease__value input:focus {\n    outline: none;    \n}\n\n.inscription-fee__increase-decrease__value input[type=number]::-webkit-inner-spin-button,\n.inscription-fee__increase-decrease__value input[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.inscription-fee__team, .inscription-fee__player {\n    gap: 100px;\n}\n\n.inscription-fee__team,\n.inscription-fee__team .left-col,\n.inscription-fee__player,\n.inscription-fee__player .left-col,\n.inscription-fee__player .right-col {\n    display: flex;\n    align-items: center;\n}\n\n.inscription-fee__player {\n    margin-top: var( --space-x3 );\n}\n\n.inscription-fee__team .left-col,\n.inscription-fee__team .right-col,\n.inscription-fee__player .left-col,\n.inscription-fee__player .right-col {\n    width: 100%;\n}\n\n.inscription-fee__team-player .icon-player, .inscription-fee__team-player .icon-team {\n    font-size: var( --space-x2 );\n    color: var( --new-green-color );\n    margin-right: 8px;\n}\n\n.inscription-fee__overall-fee{\n    display: flex;\n    justify-content: flex-start;\n    margin-top: 12px;\n}\n.inscription-fee__overall-fee div{\n    padding-bottom: 2px;\n}\n\n.inscription-fee__overall-fee .baloa-normal {\n    color: var(--primary-very-dark-color);\n    font-size: calc(var(--space) + var(--space-eighth) );/* 18px */\n}\n\n.inscription-fee__overall-fee .baloa-subtitle-2 {\n    color: var(--primary-very-dark-color);\n}\n\n.right-col_isMobile {\n    display: flex;\n    margin-left: 4rem;\n    align-items: center;\n}\n\n.inscription-fee__coupon {\n    margin-top: 30px;\n}\n\n.inscription-fee__coupon .baloa-table-column {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.inscription-fee__form {\n    margin-bottom: 44px;\n}\n\n.inscription-fee__form .input-field  {\n    margin: 0;\n    margin-top: 4px;\n    width: 100%;\n}\n\n.inscription-fee__form .input-field-label {\n    font-size: var(--space);\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.inscription-fee__form .input-field-input  {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    background: var(--white-color);\n    padding: 12px;\n}\n\n.inscription-fee__form .secondary-button {\n    padding: 10px 12px;\n    width: unset;\n    margin-top: 0;\n}\n\n.inscription-fee__form-coupon {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.inscription-fee__coupon .baloa-mini.error {\n    color: var(--error-color);\n}\n\n.inscription-fee__form .input-field.error .input-field-input {\n    border-color: var(--error-color);\n}\n\n.inscription-fee__coupon-valid {\n    border: 1px solid var(--new-green-color);\n    border-radius: 8px;\n    display: flex;\n    padding: 10px 16px 10px 12px;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 44px;\n    margin-top: 4px;\n}\n\n.inscription-fee__coupon-valid .hubicon-check_circle {\n    font-size: 24px;\n    margin-right: 12px;\n}\n\n.inscription-fee__coupon-valid .baloa-table-column {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.inscription-fee__coupon-valid .baloa-username {\n    color: var(--basic-gray-color);\n    margin-top: 4px;\n}\n\n.inscription-fee__coupon-valid .baloa-table-column.delete-button {\n    color: var(--error-color);\n    font-weight: var(--font-medium);\n    margin-left: auto;\n    cursor: pointer;\n}\n\n.inscription-fee__coupon-discount .baloa-table {\n    color: var(--primary-dark-color) !important;\n    margin-top: 16px;\n}\n\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .inscription-fee__team \n    .left-col, \n    .inscription-fee__team \n    .right-col, .inscription-fee__player \n    .left-col, .inscription-fee__player \n    .right-col {\n        width: 100%;\n    }\n\n    .inscription-fee__team, \n    .inscription-fee__team \n    .left-col, .inscription-fee__player, \n    .inscription-fee__player .left-col, \n    .inscription-fee__player .right-col {\n        display: flex;\n        align-items: center;\n    }\n\n    .inscription-fee__player {\n        margin-top: 25px;\n    }\n\n    .inscription-fee__team-player .right-col_isMobile {\n        margin-left: 2em;\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
